import React from 'react';
import { IStickyOffer } from './stickyOffer.model';
import { useStickyOfferHook } from './stickyOffer.hook';
import { StickyOfferComponent } from './stickyOffer.component';

const StickyOffer: React.FC<IStickyOffer> = (props) => {
  const { getContentHeight, slideBanner, withProgressbar, title } = props;
  const {
    showDetails,
    setShowDetails,
    toggleDetails,
    isDesktop,
    isPulsing,
    activationBoxRef,
    activationBoxHeight,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    tmpSlideBanner,
    ctaContainerRef,
    ctaContainerWidth,
    stepProgress,
    isApp,
  } = useStickyOfferHook({
    getContentHeight,
    slideBanner,
    withProgressbar,
    title,
  });
  return (
    <StickyOfferComponent
      {...props}
      showDetails={showDetails}
      setShowDetails={setShowDetails}
      toggleDetails={toggleDetails}
      activationBoxHeight={activationBoxHeight}
      activationBoxRef={activationBoxRef}
      ctaContainerWidth={ctaContainerWidth}
      ctaContainerRef={ctaContainerRef}
      stepProgress={stepProgress}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      tmpSlideBanner={tmpSlideBanner}
      isApp={isApp}
      isDesktop={isDesktop}
      isPulsing={isPulsing}
    />
  );
};

export default StickyOffer;

